import { Injector } from '@angular/core';
import { ServiceBus } from './state/service-bus.service';

export function initFactory(injector: Injector) {
  return () => {
    const serviceBus = injector.get(ServiceBus);
    return serviceBus.initialize().toPromise();
  };
}
